module.exports = __webpack_public_path__ + "static/media/site_resources_disease_state_info.7783458f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/siteResources/assets/site_resources_disease_state_info.jpeg
// module id = 1131
// module chunks = 1